import React from 'react'
import { DatePicker as BaseDatePicker } from 'baseui/datepicker'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import RequiredLabel from '@/shared/components/RequiredLabel/RequiredLabel'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import useBuildingPermit from './useBuildingPermit'
import pickedDayAsIso from '@/shared/tools/pickedDayAsIso'

const DatePicker = BaseDatePicker as React.ComponentType<any>

const BuildingPermitFields = () => {
  const {
    t,
    errors,
    isEditable,
    buildingPermitNumber,
    buildingPermitDate,
    buildingPermitEntity,
    buildingPermitCity,
    hideBuildingPermitFields,
    updateAddress,
  } = useBuildingPermit()

  if (hideBuildingPermitFields) return null

  return (
    <>
      <SDFormControl error={getError('building_permit_number', errors)}>
        <SDInput
          label={mandatoryTag + t('subscriptionForm:address_module.building_permit_fields.number')}
          disabled={isEditable === false}
          currentValue={buildingPermitNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ building_permit_number: value ?? '' })}
          error={getError('building_permit_number', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl
        label={<RequiredLabel label={t('subscriptionForm:address_module.building_permit_fields.creation_date')} />}
      >
        <DatePicker
          placeholder='DD/MM/YYYY'
          clearable
          disabled={isEditable === false}
          value={buildingPermitDate}
          maxDate={new Date(Date.now())}
          formatString='dd/MM/yyyy'
          onChange={({ date }: { date: Date | Date[] | null }) => {
            if (!date) {
              updateAddress({ building_permit_date: null })
              return
            }
            updateAddress({ building_permit_date: pickedDayAsIso(date) })
          }}
        />
      </SDFormControl>

      <SDFormControl error={getError('building_permit_city', errors)}>
        <SDInput
          label={mandatoryTag + t('subscriptionForm:address_module.building_permit_fields.issuing_city')}
          disabled={isEditable === false}
          currentValue={buildingPermitCity ?? ''}
          onBlur={(value: string | null) => updateAddress({ building_permit_city: value ?? '' })}
          error={getError('building_permit_city', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('building_permit_entity', errors)}>
        <SDInput
          label={mandatoryTag + t('subscriptionForm:address_module.building_permit_fields.issuing_entity')}
          disabled={isEditable === false}
          currentValue={buildingPermitEntity ?? ''}
          onBlur={(value: string | null) => updateAddress({ building_permit_entity: value ?? '' })}
          error={getError('building_permit_entity', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>
    </>
  )
}

export default BuildingPermitFields
